'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import H4 from 'UIComponents/elements/headings/H4';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { getSignUpUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const textKey = 'ecosystem-marketplace-solutions-ui.storefront.results.callout';
const ResultsCallout = ({
  className,
  signUpUrl
}) => {
  const h4ResponsiveProps = useResponsiveProps({
    className: {
      xs: 'text-center',
      sm: 'text-left'
    }
  });
  const pResponsiveProps = useResponsiveProps({
    className: {
      xs: 'text-center m-bottom-0',
      sm: 'text-left m-bottom-0',
      lg: 'text-left m-bottom-0'
    }
  });
  const outerGridResponsiveProps = useResponsiveProps({
    className: {
      xs: 'text-left m-x-0',
      lg: 'text-center m-x-0'
    }
  });
  const illustrationGridItemResponsiveProps = useResponsiveProps({
    className: {
      xs: 'hidden',
      sm: 'text-center p-x-0'
    }
  });
  const buttonGridItemResponsiveProps = useResponsiveProps({
    className: {
      xs: 'text-center m-top-6',
      sm: 'm-top-4 p-x-1',
      lg: 'text-center'
    }
  });
  return /*#__PURE__*/_jsx(UICardWrapper, {
    className: className,
    compact: true,
    children: /*#__PURE__*/_jsx(UICardSection, {
      className: "p-y-10",
      children: /*#__PURE__*/_jsxs(UIGrid, Object.assign({}, outerGridResponsiveProps, {
        children: [/*#__PURE__*/_jsx(UIGridItem, Object.assign({}, illustrationGridItemResponsiveProps, {
          size: {
            xs: 0,
            sm: 3,
            md: 3,
            lg: 3,
            xl: 3
          },
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "target",
            height: 100
          })
        })), /*#__PURE__*/_jsx(UIGridItem, {
          size: {
            xs: 12,
            sm: 9,
            md: 9,
            lg: 9,
            xl: 9
          },
          children: /*#__PURE__*/_jsxs(UIGrid, {
            className: "align-center",
            children: [/*#__PURE__*/_jsxs(UIGridItem, {
              className: "p-x-1",
              size: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 8,
                xl: 8
              },
              children: [/*#__PURE__*/_jsx(H4, Object.assign({}, h4ResponsiveProps, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `${textKey}.title`
                })
              })), /*#__PURE__*/_jsx("p", Object.assign({}, pResponsiveProps, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `${textKey}.description`
                })
              }))]
            }), /*#__PURE__*/_jsx(UIGridItem, Object.assign({}, buttonGridItemResponsiveProps, {
              size: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 4,
                xl: 4
              },
              children: /*#__PURE__*/_jsx(UIButton, {
                external: true,
                href: signUpUrl || getSignUpUrl(),
                truncate: true,
                use: "primary",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `${textKey}.button`
                })
              })
            }))]
          })
        })]
      }))
    })
  });
};
ResultsCallout.propTypes = {
  className: PropTypes.string,
  signUpUrl: PropTypes.string
};
export default ResultsCallout;